import { FC } from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';

interface UnsavedChangesDialogComponentProps {
  open: boolean;
  isValid?: boolean;
  onSubmit: () => void;
  onClose: () => void;
  disabled: boolean;
}

export const UnsavedChangesDialogComponent: FC<UnsavedChangesDialogComponentProps> = ({
  open,
  isValid = true,
  onSubmit,
  onClose,
  disabled,
}) => (
  <ChakraConfirmationDialog
    isOpen={open}
    title={`${isValid ? 'Save' : 'Discard'} Changes`}
    message={
      isValid
        ? 'Do you want to save your changes before leaving?'
        : 'Are you sure you want to discard the unsaved changes?'
    }
    actionButtonText={isValid ? 'Save' : 'Discard'}
    handleAction={onSubmit}
    disableActions={disabled}
    handleClose={onClose}
  />
);
